import { render, staticRenderFns } from "./templatePage.vue?vue&type=template&id=1975545d&scoped=true"
import script from "./templatePage.vue?vue&type=script&lang=js"
export * from "./templatePage.vue?vue&type=script&lang=js"
import style0 from "./templatePage.vue?vue&type=style&index=0&id=1975545d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1975545d",
  null
  
)

export default component.exports